import { jsxs, jsx } from "react/jsx-runtime";
const DotUnselected = () => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    viewBox: "0 0 16 16",
    children: [
      /* @__PURE__ */ jsx("mask", { id: "dotUnselected", fill: "#fff", children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M12.6 7.8a4.8 4.8 0 1 1-9.6 0 4.8 4.8 0 0 1 9.6 0",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.6 7.8a4.8 4.8 0 1 1-9.6 0 4.8 4.8 0 0 1 9.6 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5F5F5F",
          d: "M11.6 7.8a3.8 3.8 0 0 1-3.8 3.8v2a5.8 5.8 0 0 0 5.8-5.8h-2Zm-3.8 3.8A3.8 3.8 0 0 1 4 7.8H2a5.8 5.8 0 0 0 5.8 5.8v-2ZM4 7.8A3.8 3.8 0 0 1 7.8 4V2A5.8 5.8 0 0 0 2 7.8h2ZM7.8 4a3.8 3.8 0 0 1 3.8 3.8h2A5.8 5.8 0 0 0 7.8 2v2Z",
          mask: "url(#dotUnselected)"
        }
      )
    ]
  }
);
export {
  DotUnselected
};
